import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { LocationService } from '../proxy/planning/controllers/location.service';
import { CostReceiverService } from '@controlling/proxy/controlling/controllers/cost-receiver.service';

FieldBuilder.setNamespace('Planning');

export const STANDPERINTERMEDIATELOGYARD_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey(
    'logyardLocationId',
    'Entity.Logyard',
    LocationService
  )
    .required()
    .displayFromNested('logyardLocation.name')
    .sortBy('logyardLocation.name')
    .build(),
  FieldBuilder.foreignKey(
    'costReceiverId',
    'Entity.Location',
    CostReceiverService
  )
    .queryFilter({ costReceiverTypeName: 'Local' })
    .required()
    .display('name')
    .build(),
];

export const STANDPERINTERMEDIATELOGYARD_CONFIG = {
  entityName: 'StandPerIntermediateLogyard',
  localizationKey: 'Planning::Entity.StandPerIntermediateLogyard',
  fields: STANDPERINTERMEDIATELOGYARD_FIELDS,
  permission: 'Transport.StandPerIntermediateLogyards',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Transportation + MENU_NAME_SUFFIX,
};
